module.exports = "/assets/data/73472240dd88e0aa3cd40b9f2cff4f66-DG1.data.json";